// NX keycap (shadcn Kbd restyled): mono 10.5 px with a 2 px bottom border; KbdGroup lays several keys side by side.
import type * as React from "react";

import { cn } from "@/lib/cn";

function Kbd({ className, ...props }: React.ComponentProps<"kbd">) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        "pointer-events-none inline-flex h-5 min-w-5 items-center justify-center rounded-[5px] border border-b-2 bg-card px-[5px] font-mono text-kbd text-ink-2 select-none",
        "[[data-slot=tooltip-content]_&]:border-white/25 [[data-slot=tooltip-content]_&]:bg-transparent [[data-slot=tooltip-content]_&]:text-tooltip-foreground",
        className,
      )}
      {...props}
    />
  );
}

function KbdGroup({ className, ...props }: React.ComponentProps<"span">) {
  return (
    <span data-slot="kbd-group" className={cn("inline-flex items-center gap-1", className)} {...props} />
  );
}

export { Kbd, KbdGroup };
